export enum Locale {
    en = "en",
    ru = "ru",
    all = "all",
}
